{
  const isTouchDevice = 'ontouchstart' in window;
  const triggerSelector = 'mega-menu-horizontal > details > summary a.menu-item, dropdown-element > details > summary a.menu-item';

  const opensOnHover = (dropdown) =>
    !isTouchDevice && (dropdown.getAttribute('interaction-handler') || 'click') === 'hover';

  document.addEventListener(
    'click',
    (event) => {
      const trigger = event.target.closest?.(triggerSelector);

      if (!trigger) return;

      event.preventDefault();

      if (event.detail > 0 && opensOnHover(trigger.closest('mega-menu-horizontal, dropdown-element'))) {
        event.stopPropagation();
      }
    },
    true
  );
}
